import { render, staticRenderFns } from "./iconMe.vue?vue&type=template&id=640b3cb2&scoped=true&"
import script from "./iconMe.vue?vue&type=script&lang=js&"
export * from "./iconMe.vue?vue&type=script&lang=js&"
import style0 from "./iconMe.vue?vue&type=style&index=0&id=640b3cb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640b3cb2",
  null
  
)

export default component.exports